(function () {
  var root = document.getElementById('DDPetRoot');
  var mini = document.getElementById('DDPetMini');
  if (!root || !mini) return;

  var btn = mini.querySelector('.dd-mini__btn');
  var cartCount = parseInt(root.getAttribute('data-cart-count'), 10) || 0;
  var orders = parseInt(root.getAttribute('data-orders-count'), 10) || 0;
  var toastTimer = null;

  function toast(msg) {
    var t = mini.querySelector('.dd-mini__toast');
    if (!t) {
      t = document.createElement('div');
      t.className = 'dd-mini__toast';
      t.setAttribute('role', 'status');
      mini.appendChild(t);
    }
    t.textContent = msg;
    t.hidden = false;
    window.clearTimeout(toastTimer);
    toastTimer = window.setTimeout(function () { t.hidden = true; }, 4500);
  }

  function sparkle() {
    for (var i = 0; i < 12; i++) {
      var s = document.createElement('span');
      s.className = 'dd-spark';
      var angle = Math.random() * Math.PI * 2;
      var dist = 50 + Math.random() * 70;
      s.style.setProperty('--dx', Math.round(Math.cos(angle) * dist) + 'px');
      s.style.setProperty('--dy', Math.round(Math.sin(angle) * dist) + 'px');
      btn.appendChild(s);
      (function (el) {
        window.setTimeout(function () { if (el.parentNode) { el.parentNode.removeChild(el); } }, 1200);
      })(s);
    }
  }

  function makeSuper(celebrate, msg) {
    mini.setAttribute('data-super', '1');
    if (celebrate) {
      sparkle();
      toast(msg);
    }
  }

  if (orders > 0 || cartCount > 0) { makeSuper(false); }

  var origFetch = window.fetch;
  if (typeof origFetch === 'function') {
    window.fetch = function (input) {
      var url = '';
      try { url = typeof input === 'string' ? input : (input && input.url) || ''; } catch (e) {}
      var promise = origFetch.apply(this, arguments);
      if (url.indexOf('/cart/add') !== -1) {
        promise.then(function (res) {
          if (res && res.ok) { makeSuper(true, 'Hydration secured! I\u2019m 100% SUPER happy!'); }
        }).catch(function () {});
      }
      return promise;
    };
  }
})();